export function routing($stateProvider) {
  $stateProvider.state('index.customercare.customer.topups', {
    url: '/topups/:serviceId',
    template: '<customer-topups></customer-topups>'
  });
}